import { z } from 'zod';
import { employmentApi } from '../../../api';
import { EMPLOYMENT_EVENT_TYPES } from '../../../../constants/employmentEventTypes';
import { EVENT_ACTOR_TYPES } from '../../../../constants/employmentActorTypes';

/**
 * Validation schema for hire initiation
 */
const initiateHireSchema = z.object({
  azureId: z.uuid(),
  email: z.email(),
  fullName: z.string().min(1, 'Full name is required'),
  positionId: z.uuid().optional(),
  gradeId: z.uuid().optional(),
  contractTypeId: z.uuid().optional(),
  contractCompanyId: z.uuid().optional(),
  workingLocationId: z.uuid().optional(),
  clusterId: z.uuid().optional()
});

/**
 * Initiate Hire - Create New Employee
 *
 * @param {Object} payload - Employee data
 * @param {string} payload.azureId - Required - Azure AD ID
 * @param {string} payload.email - Required
 * @param {string} payload.fullName - Required
 * @param {string} [payload.positionId] - Optional
 * @param {string} [payload.gradeId] - Optional
 * @param {string} [payload.contractTypeId] - Optional
 * @param {string} [payload.contractCompanyId] - Optional
 * @param {string} [payload.workingLocationId] - Optional
 * @param {string} [payload.clusterId] - Optional
 * @param {string} [actorType='User'] - Actor type (System, User, Import)
 * @returns {Promise<{employeeId: string}>} - Returns employeeId for subsequent events
 * @throws {z.ZodError} - If validation fails
 */
export const initiateHire = async (payload, actorType = EVENT_ACTOR_TYPES.USER) => {
  // Validate payload
  const validatedPayload = initiateHireSchema.parse(payload);

  return await employmentApi.triggerEmploymentEvents({
    metadata: {
      actorType
    },
    events: [{
      type: EMPLOYMENT_EVENT_TYPES.HIRE,
      payload: validatedPayload
    }]
  });
};
